import { render, staticRenderFns } from "./Esqueceu_Senha.vue?vue&type=template&id=7565625a&scoped=true&"
import script from "./Esqueceu_Senha.vue?vue&type=script&lang=js&"
export * from "./Esqueceu_Senha.vue?vue&type=script&lang=js&"
import style0 from "./Esqueceu_Senha.vue?vue&type=style&index=0&id=7565625a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7565625a",
  null
  
)

export default component.exports